import { Component, signal } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink, RouterLinkActive, ConfirmDialogModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('fleetManage-front');

  constructor(private confirmationService: ConfirmationService) {}

  logout(): void {
    // TODO: Implementar lógica de logout
    // - Limpar tokens de autenticação
    // - Limpar dados do usuário
    // - Redirecionar para página de login
    
    console.log('Logout realizado');
    
    // Por enquanto, apenas recarrega a página
    // Futuramente, implementar redirecionamento para login
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja sair?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // Aqui será implementada a lógica de logout
        // localStorage.clear();
        // this.router.navigate(['/login']);
        window.location.reload();
      }
    });
  }
}